import { Link, useRouterState } from "@tanstack/react-router";
import { cn } from "@/lib/utils";

const TABS = [
  { id: "versions", label: "版本", path: "versions" as const },
  { id: "source", label: "源文", path: "source" as const },
  { id: "json-edits", label: "修改记录", path: "json-edits" as const },
  { id: "settings", label: "设置", path: "settings" as const },
];

export function CaseLevelTabs({ caseId }: { caseId: string }) {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const base = `/cases/${caseId}`;

  return (
    <nav className="-mb-px flex flex-wrap gap-0.5 border-b border-border">
      {TABS.map((tab) => {
        const isActive =
          tab.id === "versions"
            ? pathname === `${base}/versions` || pathname === `${base}/versions/`
            : pathname === `${base}/${tab.path}` ||
              pathname.startsWith(`${base}/${tab.path}/`);
        return (
          <Link
            key={tab.id}
            to={`/cases/$caseId/${tab.path}`}
            params={{ caseId }}
            className={cn(
              "relative inline-flex h-8 items-center px-2.5 text-sm font-medium text-foreground/55 transition-colors hover:text-foreground",
              isActive &&
                "text-foreground after:absolute after:inset-x-0 after:bottom-0 after:h-0.5 after:bg-foreground",
            )}
          >
            {tab.label}
          </Link>
        );
      })}
    </nav>
  );
}
